module.exports = __webpack_public_path__ + "fonts/3ef576f9d0ba104954dbc4517fd360b4.svg";